export enum SUBJECT_TYPE {
  ACADEMIC = "ACADEMIC",
  GRADE_SPECIFIC = "GRADE_SPECIFIC",
  HOLISTIC = "HOLISTIC",
}
